exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".XVdate .btn[data-v-56cea8f0]{border-color:#ccc!important;-webkit-box-shadow:none!important;box-shadow:none!important}.vc-text-sm[data-v-56cea8f0]{font-size:1rem!important}.vc-text-lg[data-v-56cea8f0]{font-size:1.1rem!important}.vc-reset input[data-v-56cea8f0]{line-height:1.428571429;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #ccc}.btnremovedate[data-v-56cea8f0],.calbtn[data-v-56cea8f0]{border-width:1px!important;line-height:1.428571429!important}", ""]);

// exports
